import { createContext, useContext } from 'react';
import { StepsType } from '@/components/stepper/Stepper';

export interface StepperContextType {
  active: number;
  steps: StepsType;
}
const StepperContext = createContext<StepperContextType>({} as StepperContextType);

export const useStepperContext = () => {
  return useContext(StepperContext);
};

export default StepperContext;
